import DateFunc from '@/lib/lyg/date_func';
import strFunc from "@/lib/lyg/string";
import DeskUseDataFunc from "@/pcomponents/common/content/edu/desk/func/desku_func";

class GetFilterUser {
  static get_is_filter_user(inData: any) {
    let opt_obj = {
      select_date: "",
      info: null,
      subject_name: "",
      now_ymdhis: "",
      is_only_now_desk: false,
      is_filter_todo_complete: false,
      is_filter_desk_complete: false,
      is_filter_absent: false,
      ...inData
    };
    let select_date = opt_obj["select_date"];
    if (strFunc.is_empty(select_date)) {
      select_date = DateFunc.get_date_format(new Date(), "Y-m-d");
    }
    let subject_name = opt_obj["subject_name"];
    let now_ymdhis = opt_obj["now_ymdhis"];
    let is_only_now_desk = opt_obj["is_only_now_desk"];
    let is_filter_todo_complete = opt_obj["is_filter_todo_complete"];
    let is_filter_desk_complete = opt_obj["is_filter_desk_complete"];
    let is_filter_absent = opt_obj["is_filter_absent"];
    let is_filter_user = false;
    let info = opt_obj["info"];
    if (info == null) {
      return is_filter_user;
    }
    
    //오늘만적용
    // if (select_date != now_ymdhis.substr(0, 10)) {
    //   return is_filter_user;
    // }
    //todo_dailyc_arr,desku_arr,attend_in_arr
    if (is_filter_todo_complete && info.todo_dailyc_arr && info.todo_dailyc_arr.length > 0) {
      for (let i = 0; i < info.todo_dailyc_arr.length; i++) {
        let todo_dailyc = info.todo_dailyc_arr[i];
        if (todo_dailyc["a_date"] == select_date
          && subject_name == todo_dailyc["a_subject"]
        ) {
          is_filter_user = true;
        }
      }
      if (is_filter_user) {
        return is_filter_user;
      }
    }

    //desk now subject filter
    if (is_only_now_desk) {
      if(info.now_desk_subject_arr&&subject_name){
        if(strFunc.str_in_array(subject_name,info.now_desk_subject_arr)==-1){
          is_filter_user = true;
        }
      }else{
        is_filter_user = true;
      }
      if(is_filter_user){
        return is_filter_user;
      }
    }

    if (is_filter_desk_complete && info.desku_arr && info.desku_arr.length > 0) {
      for (let i = 0; i < info.desku_arr.length; i++) {
        let desku = info.desku_arr[i];
        if (desku["a_date"] == select_date
          && subject_name == desku["a_subject"]
        ) {
          let row_time_data = DeskUseDataFunc.get_desk_use_time_data({
            now_ymdhis: now_ymdhis,
            desku_info: desku,
          });
          if (desku.a_is_target_time) {
            if (desku.a_is_finish) {
              is_filter_user = true;
            }
          } else {
            if (row_time_data.per_num == row_time_data.per_target_num) {
              is_filter_user = true;
            }
          }
        }
      }
      if (is_filter_user) {
        return is_filter_user;
      }
    }
    
    if (is_filter_absent && info.attend_in_arr && info.attend_in_arr.length > 0) {
      for (let i = 0; i < info.attend_in_arr.length; i++) {
        let attend_in = info.attend_in_arr[i];
        if (attend_in["a_ymd"] == select_date
          &&attend_in["a_sort_detail"]== "absent") {
          is_filter_user = true;
        }
      }
      
      if (is_filter_user) {
        return is_filter_user;
      }
    }

    return is_filter_user;
  }

  static get_is_filter_user_arr(inData: any) {
    let opt_obj = {
      select_date: "",
      info_arr: [],
      now_ymdhis: "",
      is_filter_todo_complete: false,
      is_filter_desk_complete: false,
      is_filter_absent: false,
      ...inData
    };
    let info_arr = opt_obj["info_arr"];
    let filter_user_arr: any = [];
    let info_arr_len = info_arr.length;
    let this_obj = this;

    for (let i = 0; i < info_arr_len; i++) {
      let is_filter_user = this_obj.get_is_filter_user({
        ...opt_obj,
        info: info_arr[i],
      });
      if (is_filter_user == false) {
        filter_user_arr.push(info_arr[i]);
      }
    }

    return filter_user_arr;
  }
}
export default GetFilterUser;